import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ArticleSliderItem from "../ArticleSliderItem/ArticleSliderItem";
import TitleSectionComponent from "../TitleSectionComponent/TitleSectionComponent";
import "./ArticleSlider.css";
import { MdOutlineArticle } from "react-icons/md";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";

export default function ArticleSlider() {
    const [blog, setBlog] = useState([]);
    useEffect(() => {
        axiosConfig
            .get("api/blog?page=1&pageSize=3&orderBy=RegisterDate")
            .then((result) => {
                setBlog(result.data.data);
            });
    }, []);
    return (
        <>
            <div className="article-slider">
                <Container>
                    <TitleSectionComponent
                        title="مقالات"
                        icon={<MdOutlineArticle />}
                    />
                    <Row>
                        {blog?.map((item) => (
                            <Col lg={4} key={item.id}>
                                <ArticleSliderItem item={item} />
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>

            <div className="article-slider-responsive">
                <Container>
                    <TitleSectionComponent
                        title="مقالات"
                        icon={<MdOutlineArticle />}
                    />
                    <Swiper
                        slidesPerView={2}
                        spaceBetween={10}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            300: {
                                slidesPerView: 1.5,
                                spaceBetween: 20,
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 40,
                            },
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 40,
                            },
                        }}
                        modules={[Autoplay]}
                        className="mySwiper"
                    >
                        {blog?.map((item) => (
                            <SwiperSlide key={item.id}>
                                <Link to={"/article/" + item.title}>
                                    <ArticleSliderItem item={item} />
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Container>
            </div>
        </>
    );
}
